import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GroupWord } from '../interfaces/GroupWord.interface';
import { GroupWordService } from '../service/group-word.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-group-word-view',
  templateUrl: './group-word-view.component.html',
  styleUrls: ['./group-word-view.component.css'],
})
export class GroupWordViewComponent implements OnInit {
  id: number;
  groupWord: GroupWord;

  constructor(
    private activatedRoute: ActivatedRoute,
    private groupWordsService: GroupWordService
  ) {
    activatedRoute.params.subscribe((params) => {
      this.id = params.id;
    });
    this.getCurrentGroup();
  }

  ngOnInit(): void {}

  getCurrentGroup(): Promise<any> {
    return this.groupWordsService.getById(this.id).then((res) => {
      this.groupWord = res;
    });
  }

  downloadFile(): Promise<any> {
    return this.groupWordsService.file(this.id).then((res) => {
      saveAs(res, this.groupWord.original_file_name);
    });
  }
}
